// FolderGrid.jsx              грід папок

import React from 'react';
import PropTypes from 'prop-types';

export default function FolderGrid({ folders, onOpen, isSelected, onItemClick, onItemContextMenu }) {
    return (
        <>
            <h3 className="mb-2 font-medium">Папки</h3>
            <ul className="grid gap-3 grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 mb-6">
                {folders.map(fd => {
                    const sel = !!isSelected?.(fd);
                    return (
                        <li key={fd.id}>
                            <button
                                data-sel-key={`folder:${fd.id}`}
                                // aria-selected={isSelected(fd)}
                                aria-selected={sel}
                                onClick={(e) => onItemClick ? onItemClick(fd, e) : onOpen?.(fd)}
                                onContextMenu={(e) => onItemContextMenu?.(fd, e)}
                                className={[
                                    "w-full h-28 border rounded-xl flex flex-col items-center justify-center hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400",
                                    sel ? "ring-2 ring-blue-500 bg-blue-50" : ""
                                ].join(" ")}
                                title={fd.name}
                            >
                                <span className="text-3xl">{(fd.isShortcutFolder ? '🔗' : '') + '📁'}</span>
                                <span className="text-xs mt-1 px-2 truncate block w-full text-center">{fd.name}</span>
                            </button>
                        </li>
                    );
                })}
            </ul>
        </>
    );
}


FolderGrid.propTypes = {
    folders: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        type: PropTypes.string, // може бути 'application/vnd.google-apps.folder' або '...shortcut'
        isShortcut: PropTypes.bool,
        shortcutTargetId: PropTypes.string,
        shortcutTargetMime: PropTypes.string,
    })),
    onOpen: PropTypes.func.isRequired,
    isSelected: PropTypes.func.isRequired,
    onItemClick: PropTypes.func.isRequired,
    onItemContextMenu: PropTypes.func.isRequired,
};
